import { ChevronRight } from '@mui/icons-material';
import { Box } from '@mui/material';
import { GlobalOrderItemUi } from './GlobalOrdersUi';

export const itemGenerator = (item: GlobalOrderItemUi) => {
  return [
    <>
      <Box>{item.orderNumber}</Box>
    </>,
    <>
      <Box>{item.buyerBusinessName}</Box>
    </>,
    <>
      <Box>{item.adminName}</Box>
    </>,
    <>
      <Box>{item.createdAt}</Box>
    </>,
    <>
      <Box>{item.paymentMethod}</Box>
    </>,
    <>
      <Box>${item.totalOrderAmount}</Box>
    </>,
    <>
      <ChevronRight />
    </>,
  ];
};
